import nccImg1 from '../../../assets/images/Clubs/ncc/ncc-1.webp';
import nccImg2 from '../../../assets/images/Clubs/ncc/ncc-2.webp';
import nccImg3 from '../../../assets/images/Clubs/ncc/ncc-3.webp';
import nccImg4 from '../../../assets/images/Clubs/ncc/ncc-4.webp';

import nssImg1 from '../../../assets/images/Clubs/nss/nss-1.webp';
import nssImg2 from '../../../assets/images/Clubs/nss/nss-2.webp';
import nssImg3 from '../../../assets/images/Clubs/nss/nss-3.webp';
import nssImg4 from '../../../assets/images/Clubs/nss/nss-4.webp';

export const clubsData = [
    // {
    //     id: "innovation-hub",
    //     name: "KEC Innovation & Startup Hub",
    //     category: "Technical",
    //     about: "Dedicated to fostering a culture of innovation and entrepreneurship among students by providing technical resources, mentorship, and a platform to launch startups.",
    //     objectives: [
    //         "To provide a collaborative workspace for student inventors.",
    //         "To mentor students on intellectual property and patent filing.",
    //         "To connect student startups with venture capitalists and investors.",
    //         "To conduct regular hackathons and idea pitching competitions."
    //     ],
    //     coordinators: [
    //         {
    //             name: "Dr. A. Arulvel",
    //             designation: "Chief Coordinator",
    //             dept: "Innovation Center",
    //             phone: "+91 98765 43210",
    //             email: "arulvel@kongu.ac.in",
    //             image: "" // Mock image
    //         },
    //         {
    //             name: "Mr. S. Karthick",
    //             designation: "Assistant Coordinator",
    //             dept: "CSE",
    //             phone: "+91 91234 56789",
    //             email: "karthick.cse@kongu.ac.in",
    //             image: "" // Mock image
    //         }
    //     ],
    //     activitiesSummary: {
    //         "2025-26": 5,
    //         "2024-25": 12,
    //         "2023-24": 8
    //     },
    //     eventDetails: [
    //         {
    //             year: "2025-26",
    //             events: [
    //                 {
    //                     sno: 1,
    //                     name: "Idea Pitchathon 2026",
    //                     date: "Feb 10, 2026",
    //                     details: "A campus-wide competition where students pitched their startup ideas to a panel of industrial experts."
    //                 },
    //                 {
    //                     sno: 2,
    //                     name: "Workshop on Patent Filing",
    //                     date: "Jan 15, 2026",
    //                     details: "Hands-on session on how to transform academic projects into legal patents."
    //                 }
    //             ]
    //         },
    //         {
    //             year: "2024-25",
    //             events: [
    //                 {
    //                     sno: 1,
    //                     name: "Startup Expo",
    //                     date: "Oct 22, 2024",
    //                     details: "Showcasing student-led ventures to local business leaders and alumni."
    //                 }
    //             ]
    //         }
    //     ],
    //     gallery: [
    //         "https://images.unsplash.com/photo-1517245386807-bb43f82c33c4?auto=format&fit=crop&q=80&w=800",
    //         "https://images.unsplash.com/photo-1522202176988-66273c2fd55f?auto=format&fit=crop&q=80&w=800",
    //         "https://images.unsplash.com/photo-1517245386807-bb43f82c33c4?auto=format&fit=crop&q=80&w=800",
    //         "https://images.unsplash.com/photo-1522202176988-66273c2fd55f?auto=format&fit=crop&q=80&w=800",
    //         "https://images.unsplash.com/photo-1517245386807-bb43f82c33c4?auto=format&fit=crop&q=80&w=800",
    //         "https://images.unsplash.com/photo-1522202176988-66273c2fd55f?auto=format&fit=crop&q=80&w=800",
    //         "https://images.unsplash.com/photo-1517245386807-bb43f82c33c4?auto=format&fit=crop&q=80&w=800",
    //         "https://images.unsplash.com/photo-1522202176988-66273c2fd55f?auto=format&fit=crop&q=80&w=800",
    //         "https://images.unsplash.com/photo-1517245386807-bb43f82c33c4?auto=format&fit=crop&q=80&w=800",
    //         "https://images.unsplash.com/photo-1522202176988-66273c2fd55f?auto=format&fit=crop&q=80&w=800",
    //         "https://images.unsplash.com/photo-1517245386807-bb43f82c33c4?auto=format&fit=crop&q=80&w=800",
    //         "https://images.unsplash.com/photo-1522202176988-66273c2fd55f?auto=format&fit=crop&q=80&w=800"
    //     ],
    //     driveLink: "https://drive.google.com/sample",
    //     reports: [
    //         { title: "Annual Innovation Report 2025", link: "#" },
    //         { title: "Success Stories: KEC Startups", link: "#" }
    //     ],
    //     otherDetails: "The Hub is accessible 24/7 for registered members working on approved projects."
    // },
    {
        id: "citizen-consumer",
        name: "Citizen Consumer / Legal Literacy Club",
        category: "Social",
        about: "Empowering students with knowledge about consumer rights and legal literacy to become responsible citizens.",
        objectives: [
            "To spread awareness about consumer rights and responsibilities.",
            "To promote legal literacy among the student community.",
            "To organize seminars on consumer protection laws."
        ],
        coordinators: [
            { name: "Dr. V. Vaishnavi", designation: "Coordinator", dept: "MBA", phone: "9003463969" }
        ],
        activitiesSummary: { "2025-26": 7, "2024-25": 8},
        eventDetails: [
            {
                year: "2025-26",
                events: [
                    {
                        sno: 1,
                        name: "Inaugural Function: Digital Addiction",
                        date: "Oct 13, 2025",
                        details: "Chief Guest Mr. Vinoth Sudarsanam (DSP) spoke on Overcoming Digital Addiction to promote mindful technology use and mental well-being."
                    },
                     {
                        sno: 2,
                        name: "Disaster Preparedness Project",
                        date: "Oct 4, 2025",
                        details: "Educated the local community on natural disaster prevention, early warning systems, and evacuation procedures."
                    },
                     {
                        sno: 3,
                        name: "First Aid Awareness: Act Fast, Save Lives",
                        date: "Oct 4, 2025",
                        details: "Trained 50 community participants in essential life-saving skills, including CPR, wound dressing, and fracture management."
                    },
                     {
                        sno: 4,
                        name: "Marathon for Breast Cancer Awareness",
                        date: "Oct 5, 2025",
                        details: "Organized a 10km marathon titled “Hope in Every Ribbon” to spread awareness about early detection and raise funds for patients."
                    },
                    {
                        sno: 5,
                        name: "Blood Donation Camp",
                        date: "Oct 5, 2025",
                        details: "Collected approximately 50 units of blood from public donors under medical supervision to support local healthcare needs."
                    },
                    {
                        sno: 6,
                        name: "Drug Awareness Rally & Lecture",
                        date: "Oct 8, 2025",
                        details: "Students led a rally and attended a lecture on the physical and legal consequences of addiction to promote a drug-free lifestyle."
                    },
                       {
                        sno: 7,
                        name: "Consumer Day: Intra College Fest",
                        date: "Jan 31, 2026",
                        details: "Conducted competitions in Slogan Writing, Quiz, and Essay Writing under the theme “Not Every Ad Is Your Friend”."
                    },
                       {
                        sno: 8,
                        name: "Consumer Awareness event",
                        date: "Feb 19, 2026",
                        details: "Organized by the Tamil Nadu Government to educate students on rights, responsibilities, and grievance redressal. 20 students from Kongu Engineering College participated and received certificates."
                    },

                ]
            },
             {
                year: "2024-25",
                events: [
                    {
                        sno: 1,
                        name: "Independence Day Oratorical Event",
                        date: "August 16, 2024",
                        details: "Competition on A Teens Contribution to Viksit Bharat 2047, encouraging students to share visions for India’s centenary."
                    },
                     {
                        sno: 2,
                        name: "Village Awareness: Product Safety",
                        date: "Aug 23, 2024",
                        details: "Promoted community health and safety by educating residents on product standards and safe consumption practices."
                    },
                     {
                        sno: 3,
                        name: "Community Outreach: Nutrition & Literacy",
                        date: "Aug 24, 2024",
                        details: "Conducted sessions on food security, e-banking safety, and financial literacy for rural populations."
                    },
                     {
                        sno: 4,
                        name: "CCC Inaugural Function",
                        date: "Sep 12, 2024",
                        details: "Guest Lecture by Mr.R.Rajkumar on Turning Passion into Prosperity, focusing on consumer behavior and entrepreneurial mindset."
                    },
                    {
                        sno: 5,
                        name: "National Consumer Day Rally",
                        date: "Dec 10, 2024",
                        details: "A massive rally of 500 participants urged the public to be informed about fraudulent practices and product safety laws."
                    },
                    {
                        sno: 6,
                        name: "Consumer Rights Week Competitions",
                        date: "Dec, 2024",
                        details: "Organized week-long events in drawing and poetry to highlight Digital Era Challenges and Educated Consumers."
                    },
                       {
                        sno: 7,
                        name: "World Consumer Rights Day",
                        date: "Mar 15, 2025",
                        details: "Inter-college competitions where KEC students secured top prizes in Quiz and Drawing categories."
                    },
                       {
                        sno: 8,
                        name: "Valedictory Function",
                        date: "Mar 21, 2025",
                        details: "Recognition of office bearers and academic year summary."
                    },

                ]
            }
        ]
    },
    {
        id: "cii-yi-yuva",
        name: "CII – Yi Yuva Kongu Engineering College",
        category: "Professional",
        about: "CII Yi YUVA KEC Club is to inspire, mentor, and empower students to become responsible leaders, entrepreneurs, and change-makers in society through innovation, leadership development, and social impact initiatives.",
        objectives: [
            "Promote Entrepreneurship – Encourage students to develop entrepreneurial thinking and start innovative ventures.",
            "Develop Leadership Skills – Provide opportunities for students to build leadership, communication, and decision-making skills.",
            "Industry Interaction – Connect students with industry leaders and entrepreneurs for knowledge sharing and mentorship.",
            "Encourage Innovation – Motivate students to create innovative solutions for real-world problems.",
            "Social Responsibility – Engage students in community development and social impact projects.",
            "Skill Development – Conduct workshops, training programs, and competitions to enhance professional skills.",
            "Networking Opportunities – Provide a platform for students to interact with members of Young Indians and industry experts.",
            "Career and Startup Guidance – Help students explore career paths and support them in building startups."
        ],
        coordinators: [
            { name: "Ms. M. Dharshne", designation: "Coordinator", dept: "MBA", phone: "9443752057" },
            { name: "Dr.M.Mohanasundari", designation: "Coordinator", dept: "MBA", phone: "9486763908" },
        ],
        activitiesSummary: { "2025-26": 6},
        eventDetails: [
               {
                   year: "2025-26",
                   events: [    
                     {
                   sno: 1,
                   name: "Emergency responders training program",
                   date: "August 11, 2025",
                   details: "CII YI YUVA KEC CLUB organized an organized an Emergency Responders Training Program on August 11, 2025, in Young Indians (Yi) – Erode Chapter, in partnership with EMRI Green Health Services and GVK. The session was conducted by Mr. Chandru, who provided hands-on training in first aid and emergency response techniques. Held at the 120 Lecturer Hall, the program trained MBA and B.Arch students (FN session) and NCC cadets (AN session) to respond effectively during medical emergencies. The initiative aimed to build a safety - conscious campus community and promote responsible citizenship. The program was coordinated by Dr. N. Prakash (AP – Sr.Grade/MBA), and Ms. M. Dharshne (AP/MBA)."
                  } ,
                 {
                   sno: 2,
                   name: "Certified Emergency First Aid and Basic Life Support (BLS) Training Program",
                   date: "August 18, 2025",
                   details: "CII YI YUVA KEC CLUB organized an Emergency Responders Training Program on August 18, 2025, in collaboration with Young Indians (Yi) – Erode Chapter, in partnership with EMRI Green Health Services, GVK. The session was conducted by Mr.Chandru, a certified EMRI trainer, who provided hands-on training on first aid, CPR, and emergency response techniques. Held at C.K. Prahlad Hall, MBA Block, the program trained sports students and NSS volunteers to effectively handle medical emergencies. The initiative aimed to equip students with life-saving skills and strengthen campus emergency preparedness, reflecting the institution’s commitment to student development and community service. The program was coordinated by Dr. N. Prakash (Associate Professor – Sr. Grade), and Ms. M.Dharshne (Associate Professor)."
                  },
                   {
                   sno: 3,
                   name: "Inaugural of the Club and Valedictory of Erode Varnam Vizha",
                   date: "September 16, 2025",
                   details: "The Erode Varnam Vizha Valedictory Session was held on September 16, 2025, at Kongu Engineering College, marking the conclusion of the cultural festival and the inauguration of the CII–Yi Yuva KEC Club. The event was graced by S.Kandasamy, IAS, District Collector of Erode, as Chief Guest. The program included cultural performances celebrating the heritage of Tamil Nadu and the formal inauguration of the Yi Yuva KEC Club by Ms.M.Dharshne, creating a platform for student leadership and entrepreneurship. A strategic panel discussion, moderated by Mr.T.Thiagarajan, Director of TIME Institute, featured distinguished panellists including Mr.D.Venkateswaran (Partner, CD Techno Tex LLP), Dr.K.Sudhakar (Managing Director, Sudha Hospitals), Mr. M. Chinnasami (Chairman &amp; Managing Director, Agni Steels Pvt.Ltd.), and Mr. Arachalur Selvam (State Co-ordinator,Tamil Nadu Organic Farmers Federation). The discussion focused on Erode’s development roadmap, highlighting industry modernization, healthcare expansion, sustainable agriculture, entrepreneurship, and skill development. The event also marked the launch of the Vision 2035 AI Assistant, a digital platform aimed at supporting community development and citizen engagement for the district’s future growth."
                  },
                   {
                   sno: 4,
                   name: "CII-Young Indians Thalir Young Indians Parliament",
                   date: "June 19 - 20, 2025",
                   details: "The CII Young Indians (Yi) Erode Chapter, in association with CII–Yi Yuva at Kongu Engineering College, organized the Young Indians Parliament on 19–20 June 2025 to promote democratic values, leadership, and public speaking among school students. Over 200 students from various schools participated, engaging in parliamentary- style debates and discussions to understand democratic processes and civic responsibility. The inaugural session was graced by T. Stalin Gunasekaran, while the valedictory session was attended by K. E. Prakash, MP (Lok Sabha), and Ganapathi P. Rajkumar, MP (Lok Sabha). Awards were presented to outstanding participants, and traditional Jamakkalam table mats were gifted to dignitaries to promote the local weaving heritage of Erode. The event served as a valuable platform to inspire youth to become responsible and informed citizens."
                  },
                    {
                   sno: 5,
                   name: "Yuva Entrepreneur Pitch fest - 2026",
                   date: "March 10, 2026",
                   details: "The YUVA Entrepreneur Pitch Fest 2026 was organized on 10 March 2026 at C.K. Prahalad Seminar all, MBA Block, Kongu Engineering College, Erode by the CII–Yi YUVA KEC Club in association with young Indians, an initiative of the Confederation of Indian Industry, as part of Bharat Entrepreneurship Week. The event provided a platform for student entrepreneurs to present their startup ideas and develop pitching and innovation skills. The program was graced by Krithika Shivkumar, Executive Director of TIPS and Managing Trustee of Arram Charity Trust, as the Chief Guest. Participating teams presented their business ideas, and the top three teams were recognized or their innovation and presentation. The event encouraged entrepreneurial thinking and provided networking opportunities with industry leaders."
                  },
                   {
                   sno: 6,
                   name: "Strategy Room - 2026",
                   date: "March 10, 2026",
                   details: "The Strategy Room – Case Study Challenge was organized on 10 March 2026 at C.K. Prahalad Seminar Hall, MBA Block, Kongu Engineering College, Erode by the CII–Yi YUVA KEC Club in association with Young Indians, an initiative of the Confederation of Indian Industry, as part of Bharat Entrepreneurship Week. The event aimed to enhance students’ strategic thinking and problem-solving skills through a case study challenge. Teams were given a business case 30 minutes prior to the program and presented their solutions in 10 minutes (7 minutes presentation and 3 minutes Q&A) following the format of Problem, Analysis, Strategy, and Conclusion. The program was graced by Krithika Shivkumar, Executive Director of TIPS and Managing Trustee of Arram Charity Trust, as the Chief Guest, and the best teams were recognized for their strategic insights andpresentations."
                  },

                  
                          ]
              },
                      ]
    },
    {
        id: "cloud-users",
        name: "Cloud Users Group",
        category: "Technical",
        about: "A forum for students to explore, learn and implement cloud computing technologies and architectures.",
        objectives: [
            "To provide hands-on training in cloud platforms like AWS, Azure, and Google Cloud.",
            "To foster innovation in cloud-native applications.",
            "To prepare students for cloud certifications."
        ],
        coordinators: [
            { name: "Dr. PCD. Kalaivaani", designation: "Coordinator", dept: "CSE", phone: "9659447988" },
            { name: "Dr. N. Sasipriyaa", designation: "Coordinator", dept: "CSE", phone: "9976798392" }
        ],
        activitiesSummary: { "2025-26": 9, "2024-25": 5, "2023-24": 9 },
        eventDetails: []
    },
    {
        id: "coding-forum",
        name: "Coding Forum",
        category: "Technical",
        about: "The premier hub for competitive programmers and software enthusiasts to sharpen their coding skills.",
        objectives: [
            "To conduct regular coding contests and hackathons.",
            "To provide mentorship for placements in top product-based companies.",
            "To explore new algorithms and data structures."
        ],
        coordinators: [
            { name: "Dr. R. S. Latha", designation: "Coordinator", dept: "AI", phone: "	9500459161" },
            { name: "Ms. K. Karthika", designation: "Coordinator", dept: "CT-PG", phone: "8056515700" },
            { name: "Ms. R. Subapriya", designation: "Coordinator", dept: "AI", phone: "9442732285" }
        ],
        activitiesSummary: { "2025-26": 5},
        eventDetails: []
    },
    {
        id: "cultural-music",
        name: "Cultural & Music Club",
        category: "Cultural",
        about: "Celebrating the vibrant artistic talents of KEC through music, dance, and creative expressions.",
        objectives: [
            "To provide a platform for students to showcase their musical and artistic talents.",
            "To organize annual cultural festivals and Swaram events.",
            "To train students in various art forms and instruments."
        ],
        coordinators: [
            { name: "Mr. K. V. Satheesh Kumar", designation: "Coordinator", dept: "Mech", phone: "6383219802" },
            { name: "Dr. V. N. Kowshalya", designation: "Coordinator", dept: "Chemistry", phone: "9715557900" },
             { name: "Ms. S.Sharvanthika", designation: "Coordinator", dept: "CT-UG", phone: "8778955508" },
            { name: "Ms. S. Keerthana", designation: "Coordinator", dept: "CT-UG", phone: "8870756287" }
        ],
        activitiesSummary: { "2025-26": 10, "2024-25": 13, "2023-24": 9 },
        eventDetails: []
    },
    {
        id: "energy-environment",
        name: "Energy and Environment Conservation Club",
        category: "Social",
        about: "Dedicated to promoting sustainable energy practices and environmental protection within and outside the campus.",
        objectives: [
            "To create awareness about energy conservation and renewable energy.",
            "To organize environment-friendly initiatives like tree plantation.",
            "To conduct audits and workshops on sustainability."
        ],
        coordinators: [
            { name: "Dr. S. Gomathy", designation: "Coordinator", dept: "EEE", phone: "9715063781" },
            { name: "Mr. R. Sathish Raam", designation: "Coordinator", dept: "Chemical", phone: "9789535777" }
        ],
        activitiesSummary: { "2025-26": 11, "2024-25": 8, "2023-24": 7 },
        eventDetails: []
    },
    {
        id: "english-proficiency",
        name: "English Proficiency & Readers Club",
        category: "Skill",
        about: "Enhancing communication skills and fostering a love for literature and reading among students.",
        objectives: [
            "To improve verbal and written communication in English.",
            "To encourage students to read and review books regularly.",
            "To organize debating and public speaking sessions."
        ],
        coordinators: [
            { name: "Dr. T. Geetha", designation: "Coordinator", dept: "English", phone: "8489788914" },
            { name: "Dr. B. Priyadharishini", designation: "Coordinator", dept: "English", phone: "9940902480" }
        ],
        activitiesSummary: { "2025-26": 10, "2024-25": 14, "2023-24": 12 },
        eventDetails: []
    },
    {
        id: "freelancers",
        name: "Freelancers Club",
        category: "Professional",
        about: "Connecting students with real-world projects and helping them build professional portfolios while studying.",
        objectives: [
            "To guide students on how to start their freelancing journey.",
            "To organize workshops on trending professional skills.",
            "To bridge the gap between academic learning and industry projects."
        ],
        coordinators: [
            { name: "Dr. M. Geetha", designation: "Coordinator", dept: "CSE", phone: "9489241573" },
            { name: "Mr. S. Selvaraj", designation: "Coordinator", dept: "CSD", phone: "9994284106" },
            { name: "Ms.T.E.Ramya", designation: "Coordinator", dept: "CSE", phone: "8883677334" }
        ],
        activitiesSummary: { "2025-26": 11 },
        eventDetails: []
    },
    {
        id: "gender-equality",
        name: "Gender Equality Club",
        category: "Social",
        about: "Promoting inclusive and equal opportunities for all genders on campus.",
        objectives: [
            "To foster a culture of respect and equity.",
            "To organize awareness programs on gender sensitivity.",
            "To provide a platform for discussing gender-related issues."
        ],
        coordinators: [
            { name: "Dr. K. Dinesh", designation: "Coordinator", dept: "CSE", phone: "9944846480" },
            { name: "Ms. S. Mohana Saranya", designation: "Coordinator", dept: "CSE", phone: "9942974490" }
        ],
        activitiesSummary: { "2025-26": 5, "2024-25": 6, "2023-24": 6 },
        eventDetails: []
    },
    {
        id: "ielts-club",
        name: "IELTS Club",
        category: "Skill",
        about: "Preparing students for international English language standards for global education and career opportunities.",
        objectives: [
            "To conduct mock tests and training for IELTS exams.",
            "To provide resources for language skill development.",
            "To guide students on study-abroad opportunities."
        ],
        coordinators: [
            { name: "Dr. R. Ramya Sri", designation: "Coordinator", dept: "English", phone: "8012617387" },
            { name: "Ms. S. Shobana", designation: "Coordinator", dept: "English", phone: "9360038345" }
        ],
        activitiesSummary: { "2025-26": 7, "2024-25": 9, "2023-24": 6 },
        eventDetails: []
    },
    {
        id: "karate-martial-arts",
        name: "Karate & Martial Arts Club",
        category: "Social",
        about: "Focusing on self-defense, physical fitness, and mental discipline through martial arts training.",
        objectives: [
            "To provide karate training sessions for students.",
            "To build physical endurance and mental strength.",
            "To empower students with self-defense techniques."
        ],
        coordinators: [
            { name: "Ms. K. Krishnaveni", designation: "Coordinator", dept: "Chemistry", phone: "9994814845" },
            { name: "Mr. D. Gurukumaresan", designation: "Coordinator", dept: "Maths", phone: "9751285352" }
        ],
        activitiesSummary: { "2025-26": 4, "2024-25": 7, "2023-24": 7 },
        eventDetails: []
    },
    {
        id: "mobile-app-dev",
        name: "Mobile Application Development Club",
        category: "Technical",
        about: "Fostering creativity and technical skills in mobile platform applications and multi-platform development.",
        objectives: [
            "To train students in Android and iOS development.",
            "To organize workshops on Flutter and React Native.",
            "To help students build and publish their own apps."
        ],
        coordinators: [
            { name: "Mr. A. P. Pon Selva Kumar", designation: "Coordinator", dept: "IT", phone: "9942074214" },
            { name: "Ms. P. Vanitha", designation: "Coordinator", dept: "IT", phone: "9488066933 " }
        ],
        activitiesSummary: { "2025-26": 6, "2024-25": 7, "2023-24": 7 },
        eventDetails: []
    },
    {
        id: "pasumaivanam",
        name: "Pasumaivanam Club",
        category: "Social",
        about: "The green initiative of KEC focused on campus afforestation and environmental awareness.",
        objectives: [
            "To encourage planting and conservation of native tree varieties, develop green spaces using modern ecological concepts, and motivate community participation in nature conservation.",
            "To support and promote natural farming and healthy food practices inspired by Dr. G. Nammalvar, while fostering environmental awareness and sustainable living.",
            "To restore ecological balance and protect biodiversity through native tree conservation, community-driven afforestation, and adoption of eco-friendly habits including proper waste management."
        ],
        coordinators: [
            { name: "Mr. A. Saravanan", designation: "Coordinator", dept: "Mech", phone: " 9789467617" },
            { name: "Dr. P. Srinivasan", designation: "Coordinator", dept: "Chemistry", phone: "9788632868" }
            
        ],
        activitiesSummary: { "2025-26": 11, "2024-25": 14, "2023-24": 8 },
        eventDetails: []
    },
    {
        id: "photography-design",
        name: "Photography & Design Club",
        category: "Cultural",
        about: "Visualizing the spirit of KEC through the lens and creative digital design.",
        objectives: [
            "To document college events through professional photography.",
            "To train students in graphic design and video editing.",
            "To conduct workshops and exhibitions of student work."
        ],
        coordinators: [
            { name: "Mr. N. P. Saravanan", designation: "Coordinator", dept: "CSE", phone: "9976874089" },
            { name: "Mr. S. K. Logesh", designation: "Coordinator", dept: "EEE", phone: "9443350335" }
        ],
        activitiesSummary: { "2025-26": 6, "2024-25": 8, "2023-24": 8 },
        eventDetails: []
    },
    {
        id: "quiz-club",
        name: "Quiz Club",
        category: "Skill",
        about: "Challenging minds and expanding horizons through intellectual competition and knowledge sharing.",
        objectives: [
            "To foster a culture of quizzing and general knowledge.",
            "To prepare students for national level quiz competitions.",
            "To organize regular brain-storming sessions."
        ],
        coordinators: [
            { name: "Dr. K. Senthilkumar", designation: "Coordinator", dept: "Food Tech", phone: "9842844880" },
            { name: "Dr. S. Sathya", designation: "Coordinator", dept: "Maths", phone: "9688009938" }
        ],
        activitiesSummary: { "2025-26": 5, "2024-25": 8, "2023-24": 8 },
        eventDetails: []
    },
    {
        id: "ravi-varma-creative",
        name: "Ravi Varma Creative Club",
        category: "Cultural",
        about: "Bringing out the inner artist through fine arts, sketching, and traditional creative disciplines.",
        objectives: [
            "To encourage students in sketching, painting and digital arts.",
            "To host art exhibitions on campus.",
            "To organize workshops on traditional and modern art forms."
        ],
        coordinators: [
            { name: "Dr. V. Sampath Kumar", designation: "Coordinator", dept: "Civil", phone: "9047151001" },
            { name: "Mr. S. Jegan", designation: "Coordinator", dept: "EIE", phone: "7598279706" }
        ],
        activitiesSummary: { "2025-26": 6, "2024-25": 6, "2023-24": 8 },
        eventDetails: []
    },
    {
        id: "red-ribbon",
        name: "Red Ribbon Club",
        category: "Social",
        about: "Focusing on health awareness, voluntary blood donation and youth social impact.",
        objectives: [
            "To promote voluntary blood donation among youth.",
            "To create awareness about health issues like HIV/AIDS.",
            "To encourage students to participate in social service."
        ],
        coordinators: [
            { name: "Dr. V. Yamuna", designation: "Coordinator", dept: "Maths", phone: "	9698919364 " },
            { name: "Mr. V. Parthibaraj", designation: "Coordinator", dept: "Physics", phone: "9080554215" }
        ],
        activitiesSummary: { "2025-26": 8, "2024-25": 5},
        eventDetails: []
    },
    {
        id: "robotics-club",
        name: "Robotics Club",
        category: "Technical",
        about: "Where machines come to life through student innovation and engineering excellence.",
        objectives: [
            "To design and build autonomous and manual robots.",
            "To compete in state and national level robotics events.",
            "To provide a workspace for student hardware projects."
        ],
        coordinators: [
            { name: "Dr. S. K. Thangarasu", designation: "Coordinator", dept: "MTS", phone: "9942783338" },
            { name: "Mr. S. Santhoshkumar", designation: "Coordinator", dept: "MTS", phone: "9025232091" }
        ],
        activitiesSummary: { "2025-26": 8, "2024-25": 9, "2023-24": 9 },
        eventDetails: []
    },
    {
        id: "rotaract-club",
        name: "Rotaract Club",
        category: "Social",
        about: "Developing young leaders through community service and international friendship projects.",
        objectives: [
            "To organize community outreach programs.",
            "To provide leadership and professional development training.",
            "To collaborate on international community projects."
        ],
        coordinators: [
            { name: "Dr. K. Vishnuvardhan", designation: "Coordinator", dept: "Civil", phone: "9791674174" }
        ],
        activitiesSummary: { "2025-26": 4, "2024-25": 4, "2023-24": 6 },
        eventDetails: []
    },
    {
        id: "self-development",
        name: "Self-Development Club",
        category: "Skill",
        about: "Unlocking human potential through personality development, life skills, and soft skill training.",
        objectives: [
            "To build student self-confidence and public speaking skills.",
            "To conduct workshops on life-skills and emotional intelligence.",
            "To help students develop a positive and growth-oriented mindset."
        ],
        coordinators: [
            { name: "Dr. N. Prakash", designation: "Coordinator", dept: "MBA", phone: " 9842721589" },
            { name: "Dr. S. Kavitha Bharathi", designation: "Coordinator", dept: "CT-UG", phone: "9965540601" }
        ],
        activitiesSummary: { "2025-26": 8, "2024-25": 5, "2023-24": 9 },
        eventDetails: []
    },
    {
        id: "mathematics-club",
        name: "Srinivasa Ramanujan Mathematics Club",
        category: "Skill",
        about: "Exploring the beauty and power of mathematics beyond the standard curriculum.",
        objectives: [
            "To popularize mathematics as a fascinating subject.",
            "To conduct monthly math quizzes and puzzles.",
            "To help students prepare for competitive exams."
        ],
        coordinators: [
            { name: "Dr. AL. Nachammai", designation: "Coordinator", dept: "Maths", phone: "9095059729" },
            { name: "Dr. K. Radhika", designation: "Coordinator", dept: "Maths", phone: "	9150780480" }
        ],
        activitiesSummary: { "2025-26": 7, "2024-25": 13, "2023-24": 10 },
        eventDetails: []
    },
    {
        id: "tamil-mandram",
        name: "Tamil Mandram",
        category: "Cultural",
        about: "Preserving and promoting the rich cultural heritage and literature of the Tamil language.",
        objectives: [
            "To organize debates and literary events in Tamil.",
            "To celebrate Tamil traditional festivals on campus.",
            "To encourage writing and creative expression in Tamil."
        ],
        coordinators: [
            { name: "Dr. A. S. Periasamy Manikandan", designation: "Coordinator", dept: "Chemical", phone: "9442520334" },
            { name: "Dr. R. Mouleeshuwarapprabu", designation: "Coordinator", dept: "EIE", phone: "9786664799" }
        ],
        activitiesSummary: { "2025-26": 17, "2024-25": 16, "2023-24": 18 },
        eventDetails: []
    },
    {
        id: "women-development",
        name: "Women Development Cell",
        category: "Social",
        about: "Empowering women students and faculty through awareness, safety, and leadership initiatives.",
        objectives: [
            "To promote women's empowerment and leadership on campus.",
            "To create awareness about women's rights and safety.",
            "To organize workshops on entrepreneurship for women."
        ],
        coordinators: [
            { name: "Dr. D. Malathi", designation: "Coordinator", dept: "ECE", phone: "9842780385" },
            { name: "Dr. A. Revathi", designation: "Coordinator", dept: "Chemistry", phone: "9942303014" }
        ],
        activitiesSummary: { "2025-26": 24, "2024-25": 28, "2023-24": 15 },
        eventDetails: []
    },
    {
        id: "yoga-meditation",
        name: "Yoga and Meditation Club",
        category: "Social",
        about: "Nurturing physical health and mental peace through the ancient practices of Yoga and Meditation.",
        objectives: [
            "To conduct regular yoga and meditation sessions.",
            "To promote mental wellness and stress reduction.",
            "To teach life-balancing techniques for students."
        ],
        coordinators: [
            { name: "Dr. R. Thamilselvan", designation: "Coordinator", dept: "CSE", phone: "9443916069" },
            { name: "Dr. P. Vadivel", designation: "Coordinator", dept: "Maths", phone: "9842122611" },
            { name: "Dr. L. Rahunathan", designation: "Coordinator", dept: "MCA", phone: "9095296777" }
        ],
        activitiesSummary: { "2025-26": 2, "2024-25": 3, "2023-24": 2 },
        eventDetails: []
    },
    {
        id: "youth-red-cross",
        name: "Youth Red Cross",
        category: "Social",
        about: "Training youth in humanitarian values and disaster preparedness.",
        objectives: [
            "To provide first-aid and medical disaster training.",
            "To promote health and hygiene awarenes.",
            "To organize community service and relief camps."
        ],
        coordinators: [
            { name: "Dr. G. Mugaishudeen", designation: "Coordinator", dept: "Chemical", phone: "9842040470" },
            { name: "Dr. S. Yamunadevi", designation: "Coordinator", dept: "Maths", phone: "9942663067" }
        ],
        activitiesSummary: { "2025-26": 3, "2024-25": 5, "2023-24": 5 },
        eventDetails: []
    },
    {
        id: "road-safety",
        name: "Road Safety Club",
        category: "Social",
        about: "Dedicated to saving lives through awareness and adherence to road safety rules.",
        objectives: [
            "To create awareness about safe driving practices.",
            "To organize rallies and seminars on traffic rules.",
            "To conduct mock safety drills."
        ],
        coordinators: [
            { name: "Mr. R. Gowtham", designation: "Coordinator", dept: "Automobile", phone: "9629702739" },
            { name: "Mr. T. Surendran", designation: "Coordinator", dept: "Mechatronics", phone: "7358761043" },

        ],
        activitiesSummary: { "2025-26": 2 },
        eventDetails: []
    },
    {
        id: "sdg-cell",
        name: "SDG Cell",
        category: "Social",
        about: "Working towards the United Nations Sustainable Development Goals on campus.",
        objectives: [
            "To promote awareness about the 17 UN SDGs.",
            "To implement projects addressing sustainability and poverty.",
            "To align institutional practices with global sustainability goals."
        ],
        coordinators: [
            { name: "Dr. M. Sivachitra", designation: "Coordinator", dept: "EEE", phone: "9787325879" },
            { name: "Dr. C. Gomadurai", designation: "Coordinator", dept: "Civil", phone: "94430 29421" }
        ],
        activitiesSummary: { "2025-26": 3 },
        eventDetails: [ ]
    },
    {
        id: "watts-next",
        name: "WATT’S NEXT ",
        category: "Technical",
        about: "To create a dynamic platform that nurtures innovation and practical learning by strengthening students’ technical knowledge, inspiring them to design and develop product-based solutions, providing industry and research exposure, and enhancing their problem-solving and presentation skills.",
        objectives: [
            "To develop the technical knowledge of first-year students to conceptualize and present product development ideas.",
            "To create a platform for product development through industrial training.",
            "To impart hands-on experience in essential engineering practices, including case studies, problem-solving, and scholarly presentations.",
            "To coordinate visits to reputed research laboratories and promote research and development (R&D) activities among students and faculty."

        ],
        coordinators: [
            { name: "Dr. P. Manikandan", designation: "Coordinator", dept: "Chemistry", phone: "9715508383" },
            { name: "Mr. V. Parthibaraj", designation: "Coordinator", dept: "Physics", phone: "	9080554215" },
            { name: "Mr. R. Thirumalairajan", designation: "Coordinator", dept: "English", phone: "7904544862" }
        ],
        activitiesSummary: {  },
        eventDetails: []
    },
    {
        id: "nss",
        name: "National Service Scheme (NSS)",
        category: "NSS",
        about: "Developing student personality through community service and active engagement in social causes.",
        objectives: [
            "To understand the community in which they work.",
            "To identify the needs and problems of the community and involve them in problem-solving.",
            "To develop among themselves a sense of social and civic responsibility."
        ],
        coordinators: [
            { name: "NSS Coordinator", designation: "Coordinator", dept: "Various", phone: "" }
        ],
        activitiesSummary: { "2025-26": 5, "2024-25": 8, "2023-24": 10 },
        eventDetails: [],
        gallery: [nssImg1, nssImg2, nssImg3, nssImg4]
    },
    {
        id: "ncc",
        name: "National Cadet Corps (NCC)",
        category: "NCC",
        about: "Developing character, comrade-ship, discipline, leadership, secular-outlook, spirit of adventure and ideals of selfless service.",
        objectives: [
            "To Create a Human Resource of Organized, Trained and Motivated Youth.",
            "To Provide Leadership in all Walks of life and be Always Available for the Service of the Nation.",
            "To Provide a Suitable Environment to Motivate the Youth to Take Up a Career in the Armed Forces."
        ],
        coordinators: [
            { name: "NCC Officer", designation: "Coordinator", dept: "Various", phone: "" }
        ],
        activitiesSummary: { "2025-26": 6, "2024-25": 12, "2023-24": 15 },
        eventDetails: [],
        gallery: [nccImg1, nccImg2, nccImg3, nccImg4]
    }
     
];
